module.exports = __webpack_public_path__ + "static/media/instagram-relax-mobile.8aee15a2.png";